export class OptionModel<T = any> {
    label: string;
    value: T;

    constructor(label?: string, value?: T) {
        this.label = label;
        this.value = value;
    }
}

export class DropdownOptionModel<T = any> extends OptionModel {
    subLabel?: string;
    icon?: string;
    tooltip?: string;
    disabled?: boolean;

    constructor(label?: string, value?: T, subLabel?: string, icon?: string, tooltip?: string) {
        super(label, value);
        this.subLabel = subLabel;
        this.icon = icon;
        this.tooltip = tooltip;
    }
}

export class MultiSelectDropdownOptionModel<T = any> extends DropdownOptionModel {
    selected: boolean;

    constructor(label?: string, value?: T, selected?: boolean) {
        super(label, value);
        this.selected = selected ? selected : false;
    }
}

export interface MultiSelectDropdownOptionGroup {
    label?: string;
    expanded?: boolean;
    type?: any;
    options?: MultiSelectDropdownOptionModel[];
}

export class CustomDropdownOption<T = any> extends DropdownOptionModel {
    action: () => void;

    constructor(label: string, value: T, action: () => void) {
        super(label, value);
        this.action = action;
    }
}

